import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=ddf5e726&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"
import style0 from "./Companies.vue?vue&type=style&index=0&id=ddf5e726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf5e726",
  null
  
)

export default component.exports